(function () {
  var GRID = '[data-r3nu-blog-grid]';

  function filterSlug(el) {
    if (!el) return '';
    var v = el.getAttribute('data-r3nu-cat');
    if (v == null || v === '') v = el.getAttribute('data-category');
    if (v == null || v === '') v = el.getAttribute('data-filter') || '';
    return String(v).trim().toLowerCase();
  }

  function initGrid(root) {
    if (root.getAttribute('data-r3nu-blog-grid-init') === '1') return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-article-card]'));
    if (!cards.length) return;

    root.setAttribute('data-r3nu-blog-grid-init', '1');

    var filterButtons = Array.prototype.slice.call(
      root.querySelectorAll('.r3nu-blog-grid__filter[data-r3nu-cat]')
    );
    if (filterButtons.length === 0) {
      filterButtons = Array.prototype.slice.call(root.querySelectorAll('.r3nu-blog-grid__filter'));
    }

    var loadMoreBtn = root.querySelector('[data-load-more]');
    var initialVisible = parseInt(String(root.getAttribute('data-initial-visible') || '6'), 10) || 6;
    var loadStep = parseInt(String(root.getAttribute('data-load-step') || '6'), 10) || 6;

    var activeFilter = 'all';
    var visibleCount = initialVisible;

    function cardSlug(card) {
      return filterSlug(card);
    }

    function buttonSlug(btn) {
      return filterSlug(btn) || 'all';
    }

    function matchingCards() {
      if (activeFilter === 'all') {
        return cards;
      }
      return cards.filter(function (card) {
        return cardSlug(card) === activeFilter;
      });
    }

    function sync() {
      var match = matchingCards();
      match.forEach(function (card, index) {
        card.hidden = index >= visibleCount;
      });
      cards.forEach(function (card) {
        if (match.indexOf(card) === -1) {
          card.hidden = true;
        }
      });

      if (loadMoreBtn) {
        loadMoreBtn.hidden = match.length <= visibleCount;
      }

      filterButtons.forEach(function (btn) {
        var f = buttonSlug(btn);
        var isActive = f === activeFilter;
        btn.classList.toggle('r3nu-blog-grid__filter--active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function onFilterClick() {
      /* `this` is the button */
      activeFilter = buttonSlug(this);
      if (activeFilter === '') activeFilter = 'all';
      visibleCount = initialVisible;
      sync();
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', onFilterClick);
    });

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        visibleCount += loadStep;
        sync();
      });
    }

    sync();
  }

  function boot(scope) {
    var el = scope && scope.querySelectorAll ? scope : document;
    el.querySelectorAll(GRID).forEach(function (root) {
      initGrid(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector(GRID)) {
      boot(e.target);
    }
  });
})();
